import React from 'react';
import './LoaderLogo.css';

const LogoLoader = ({ theme }) => (
  <div
    className="loader-container"
    style={{ '--body-color': theme.body }}
  >
    <svg
      className="loader-svg"
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* 1) hexagon outline */}
      <polygon
        className="hexagon"
        points="100,10 180,60 180,140 100,190 20,140 20,60"
        stroke="var(--body-color)"
        strokeWidth="4"
        fill="none"
      />

      {/* 2) first initial */}
      <text
        className="initial initial1"
        x="45%"
        y="58%"
        textAnchor="middle"
        alignmentBaseline="middle"
        fontFamily="Montserrat"
        fontSize="48"
        fill="var(--body-color)"
      >
        P
      </text>

      {/* 3) second initial */}
      <text
        className="initial initial2"
        x="55%"
        y="58%"
        textAnchor="middle"
        alignmentBaseline="middle"
        fontFamily="Montserrat"
        fontSize="48"
        fill="var(--body-color)"
      >
        P
      </text>
    </svg>

    {/* 4) split name into two words */}
    <div className="loader-name">
      <span className="word word1">Pratik</span>
      <span className="word word2">Poudel</span>
    </div>
  </div>
);

export default LogoLoader;
